import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ArrowUpRight, Clock } from "lucide-react";

export default function Courses() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
  }, []);

  return (
    <section id="courses" className="py-24 bg-white" data-testid="courses-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="overline text-[#E07A5F]">Programs</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl text-[#1B4332] mt-3 leading-tight">
              Quality Education for Career Growth
            </h2>
            <p className="mt-4 text-[#5C6661] leading-relaxed">
              Our courses are designed to provide practical, industry-relevant skills
              that prepare you for the modern workplace.
            </p>
          </div>
          <div className="hidden md:flex flex-col items-end text-right">
            <div className="font-serif-display text-5xl text-[#1B4332]">{courses.length}</div>
            <div className="text-xs uppercase tracking-widest text-[#5C6661]">Certified Programs</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="courses-list">
          {courses.map((c, idx) => (
            <div
              key={c.code}
              className="group relative bg-[#F9F8F6] border border-border rounded-2xl p-7 hover:border-[#1B4332] transition-all hover:shadow-md"
              data-testid={`course-card-${c.code}`}
            >
              <div className="flex items-start justify-between mb-5">
                <span className="inline-flex items-center gap-1.5 text-xs font-mono px-3 py-1 rounded-full bg-[#1B4332] text-white">
                  {c.code}
                </span>
                <ArrowUpRight className="w-5 h-5 text-[#5C6661] group-hover:text-[#E07A5F] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
              </div>
              <h3 className="font-serif-display text-2xl text-[#1B4332] leading-tight">{c.name}</h3>
              <p className="mt-3 text-sm text-[#5C6661] leading-relaxed">{c.description}</p>
              <div className="mt-5 pt-4 border-t border-border flex items-center gap-2 text-xs text-[#5C6661]">
                <Clock className="w-3.5 h-3.5" />
                <span>{c.duration}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#1B4332] rounded-3xl p-10 sm:p-14 text-white grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="font-serif-display text-3xl sm:text-4xl leading-tight">
              Ready to Start Your Journey?
            </h3>
            <p className="mt-3 text-stone-200 text-sm">
              Contact us to learn more about our courses and enrollment process.
              We're here to help you achieve your career goals.
            </p>
          </div>
          <div className="md:text-right">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-[#E07A5F] hover:bg-[#E28B75] text-white px-7 py-3.5 rounded-full text-sm font-semibold transition-colors"
              data-testid="cta-enroll-btn"
            >
              Enroll Now <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
